/**
 * Preset connection color swatches (Tailwind 500 shades).
 * Each entry has a hex value and a human-readable label for accessibility.
 */
export const CONNECTION_COLOR_PRESETS = [
  { hex: '#EF4444', label: 'Red' },
  { hex: '#F97316', label: 'Orange' },
  { hex: '#F59E0B', label: 'Amber' },
  { hex: '#EAB308', label: 'Yellow' },
  { hex: '#84CC16', label: 'Lime' },
  { hex: '#22C55E', label: 'Green' },
  { hex: '#10B981', label: 'Emerald' },
  { hex: '#14B8A6', label: 'Teal' },
  { hex: '#06B6D4', label: 'Cyan' },
  { hex: '#0EA5E9', label: 'Sky' },
  { hex: '#3B82F6', label: 'Blue' },
  { hex: '#6366F1', label: 'Indigo' },
  { hex: '#8B5CF6', label: 'Violet' },
  { hex: '#A855F7', label: 'Purple' },
  { hex: '#D946EF', label: 'Fuchsia' },
  { hex: '#EC4899', label: 'Pink' },
  { hex: '#F43F5E', label: 'Rose' },
  { hex: '#64748B', label: 'Slate' },
] as const;

/** Validate that a string is a valid hex color (#RRGGBB or #RGB) or undefined */
export function isValidConnectionColor(color: string | undefined): boolean {
  if (color === undefined || color === '') return true;
  return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(color);
}
